var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-8 w-8 rounded-full bg-ayadi-900 flex justify-center items-center",class:{ 'ml-0': _vm.arabic }},[_c('img',{staticClass:"w-3 h-auto",attrs:{"src":require("../../assets/images/full_arrow_right.svg"),"alt":"arrow-right"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }